exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-container[data-v-43c834cc]{z-index:999;width:450px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.slide-enter-active[data-v-43c834cc]{transition-duration:.1s;transition-timing-function:ease}.slide-enter-to[data-v-43c834cc],.slide-leave[data-v-43c834cc]{max-height:100px;overflow:hidden}.slide-enter[data-v-43c834cc],.slide-leave-to[data-v-43c834cc]{overflow:hidden;max-height:0}", ""]);

// exports
